import {API_SERVERLESS, getFetch} from '../../commonApi';

export function apiCommunicationCentreModalInternalMessageHistory(correlationId: number) {
    return getFetch(
        `${API_SERVERLESS}/communicationCentreModalInternal/v4/CCMIH/messageHistory/${correlationId}`,
        true
    );
}
